import { render, staticRenderFns } from "./SimpleHeaderNoBackground.vue?vue&type=template&id=0eebf28c&name=simple-header-no-background&"
import script from "./SimpleHeaderNoBackground.vue?vue&type=script&lang=js&"
export * from "./SimpleHeaderNoBackground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports